import React from 'react';
const FilterDateRange = props => <div className={props.className}>DateRangeFilter</div>;
export default FilterDateRange;
